export default __webpack_public_path__ + "static/media/banner1.e5bb6c65.png";